export default __webpack_public_path__ + "locales/lv/About.json?hash=acb9affa9dae06441365da186a379dde";